<lib-dialog [onOkay]="onOkay">
  <ng-template>
    <attributes-editor
      (blurred)="doSaveDocument($event)"
      [dataSource]="editorDataSource"
      [mode]="genericAttributeService.mode"
      [entityId]="genericAttributeService.entityId"
      [hideLabel]="true"
    ></attributes-editor>
  </ng-template>
</lib-dialog>
